module.exports = __webpack_public_path__ + "static/facebook-image-3a1979dc8745b1c2b2be33cf7213bbf8.jpg";